import { render, staticRenderFns } from "./up_files.vue?vue&type=template&id=054d59ce&scoped=true"
import script from "./up_files.vue?vue&type=script&lang=js"
export * from "./up_files.vue?vue&type=script&lang=js"
import style0 from "./up_files.vue?vue&type=style&index=0&id=054d59ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d59ce",
  null
  
)

export default component.exports